import type { AdminUser } from '../types';

export const setAdminToken = (token: string): void => {
  localStorage.setItem('adminToken', token);
};

export const getAdminToken = (): string | null => {
  return localStorage.getItem('adminToken');
};

export const removeAdminToken = (): void => {
  localStorage.removeItem('adminToken');
};

export const setAdminUser = (user: AdminUser): void => {
  localStorage.setItem('adminUser', JSON.stringify(user));
};

export const getAdminUser = (): AdminUser | null => {
  const user = localStorage.getItem('adminUser');
  return user ? JSON.parse(user) : null;
};

export const removeAdminUser = (): void => {
  localStorage.removeItem('adminUser');
};

export const isAuthenticated = (): boolean => {
  return !!getAdminToken() && !!getAdminUser();
};

export const hasRole = (user: AdminUser | null, requiredRoles: string[]): boolean => {
  if (!user) return false;
  return requiredRoles.includes(user.role);
};

export const canAccessAdminPanel = (user: AdminUser | null): boolean => {
  if (!user) return false;
  return ['super-admin', 'admin', 'editor'].includes(user.role);
};
